import React, { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { DefaultValues, useForm } from 'react-hook-form';
import { FieldOptionInterface } from '@families-link/shared';

type SchoolFilterFormValues = {
	schools: any[];
};

export const useSchoolFilter = (initialSchools?: any[]) => {
	const [schools, setSchools] = useState<FieldOptionInterface[]>(initialSchools || []);

	const schoolIds = schools.map((s) => s._id);

	const defaultValues: DefaultValues<SchoolFilterFormValues> = {
		schools: initialSchools || [],
	};

	const { register, getValues, control, watch } = useForm({
		defaultValues,
	});

	const filter = watch('schools');

	const debouncedUpdate = useCallback(
		debounce((list?: FieldOptionInterface[]) => {
			setSchools(list || []);
		}, 300),
		[]
	);

	useEffect(() => {
		debouncedUpdate(filter);
	}, [filter, debouncedUpdate]);

	return {
		register,
		getValues,
		control,
		schools,
		schoolIds,
	};
};
